<template>
  <div class="country__wrapper">
    <component
      :is="link ? 'nuxt-link' : 'div'"
      :to="link"
      class="country"
      :class="{
        state: isState,
        'not-active': notActive,
      }"
    >
      <div :class="`country__icon-${size}`">
        <img :src="flagIcon" :alt="text" />
        <span v-if="text && size !== 'verysmallpadded'" class="caption">{{
          text
        }}</span>
        <span v-else class="verysmallcaption">{{ text }}</span>
      </div>
    </component>
  </div>
</template>

<script>
import CountryFlag from "vue-country-flag";

export default {
  name: "Country",
  components: {
    CountryFlag,
    Tooltip: () => import("../elements/Tooltip"),
  },
  props: {
    isState: {
      type: Boolean,
      default: false,
    },
    notActive: {
      type: Boolean,
      default: false,
    },
    link: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: null,
    },
    iso: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    access: {
      type: Boolean,
      default: null,
    },
    size: {
      type: String,
      default: "default",
    },
  },
  data() {
    return {
      notSubscribe: false,
    };
  },
  computed: {
    flagIcon() {
      if (this.icon) {
        // For now the URL is public for the SVGs so we can access the URL directly
        // this doesn't seem right.
        return `${this.$config.baseURL}${this.icon}`;
      }
      return require("~/assets/images/flags/vixiocircleflag.svg");
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.country {
  display: flex;
  align-items: top;
  color: $text_gray;
  font-size: 1.6rem;
  text-decoration: none;
  transition: 0.3s ease-out;
  .recentupdate__title {
    font-weight: bold;
  }
  &__wrapper {
    position: relative;
  }
  &:hover {
    color: $brightGreen;
  }
  &__icon-default {
    img {
      width: 5rem;
      height: 5rem;
      object-fit: cover;
      margin: 0 auto;
      display: block;
    }
  }
  &__icon-small {
    img {
      width: 4rem;
      height: 4rem;
      object-fit: cover;
      margin: 0 auto;
      display: block;
    }
  }

  &__icon-smallpadded {
    margin-right: 1.6rem;
    display: flex;

    img {
      width: 2.5rem;
      height: 2.5rem;
      object-fit: cover;
      margin: 0 auto;
      display: block;
    }
  }
  &__icon-verysmallpadded {
    margin-right: 1.6rem;
    margin-left: 1rem;
    display: flex;
    align-items: center;

    img {
      width: 1.8rem;
      height: 1.8rem;
      object-fit: cover;
      margin: 0 auto;
      display: block;
    }
  }
  .caption {
    margin-top: 1rem;
    display: block;
    font-weight: 600;
    line-height: 120%;
    text-align: center;
    align-items: center;
    justify-content: center;
    overflow-wrap: break-word;
    font-size: 1.4rem;
  }

  .verysmallcaption {
    // margin-top: 1rem;
    display: block;
    font-weight: 600;
    line-height: 120%;
    text-align: center;
    align-items: center;
    justify-content: center;
    overflow-wrap: break-word;
    font-size: 1.4rem;
    padding-left: 1rem;
    padding-block: 0.5rem;
  }
  &.state {
    font-size: 1.4rem;
    .country__icon {
      width: 4rem;
      height: 2rem;
    }
    span {
      width: calc(100% - 3.6rem);
    }
  }
  &.not-active {
    opacity: 0.7;
    display: inline-block;
    &:hover {
      color: $text_gray;
    }
  }
}
</style>
